import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal, Eyebrow } from './Section';
import { IMAGES } from './constants';
const results = ['Tu portfolio profesional listo para presentarte ante marcas.', 'Tus servicios, paquetes y precios en dólares definidos.', 'Un sistema para contactar y hacer seguimiento a +80 marcas.', 'Claridad total sobre tu camino hacia tus primeros ingresos en dólares.'];
export function Transformation() {
  return <section className="w-full bg-plum py-16 text-cream sm:py-24" data-id="element-194" data-mp="11ilps21m409l">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 px-5 sm:px-6 lg:grid-cols-2" data-id="element-195" data-mp="16a3p6lnzlssg">
        <Reveal className="order-2 lg:order-1" data-id="element-196" data-mp="1abgxd2ejy82j">
          <div className="relative mx-auto w-full max-w-md" data-id="element-197" data-mp="1ab785h1c04xw">
            <div className="absolute -inset-3 rounded-[2rem] bg-coral/20 blur-md" data-id="element-198" data-mp="1fbbmb0eronky" />
            <img src={IMAGES.transformation} alt="Creadora UGC rodeada de productos y oportunidades de colaboración con marcas" className="relative aspect-[4/5] w-full rounded-[1.6rem] object-cover shadow-soft" data-id="element-199" data-mp="1k9myviwg5c6v" />
          </div>
        </Reveal>

        <Reveal className="order-1 lg:order-2" delay={0.1} data-id="element-200" data-mp="13528vt227qgv">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-gold-soft" data-id="element-201" data-mp="135lr7avmggvf">
            Tu futuro en 7 días
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight sm:text-4xl" data-id="element-202" data-mp="1uwrl39kr1ic9">
            Imaginá despertar sabiendo{' '}
            <span className="text-coral-light" data-id="element-203" data-mp="1qvpv7jcq2imy">exactamente qué hacer</span>
          </h2>
          <p className="mt-4 text-cream/75" data-id="element-204" data-mp="1m2myx3gk8v32">
            Dejás de improvisar y de sentir que estás pidiendo un favor. Tenés un método claro,
            organizado y profesional para transformar tu habilidad de crear contenido en una
            nueva fuente de ingresos.
          </p>

          <ul className="mt-8 space-y-3.5" data-id="element-205" data-mp="29sqzt32d6gqd">
            {results.map(r => <li key={r} className="flex items-start gap-3" data-id="element-206" data-mp="2spr7acxpx25i">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-coral-light" data-id="element-207" data-mp="2ssdfmesfnlos" />
                <span className="text-cream/90" data-id="element-208" data-mp="2xr85g0otiaie">{r}</span>
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-209" data-mp="2jvwdg121qy56">
            <CTAButton data-id="element-210" data-mp="2nysn329lzjwz">Quiero esta transformación</CTAButton>
          </div>
        </Reveal>
      </div>
    </section>;
}